export default __webpack_public_path__ + "static/O0117-58c3e180d2e37bd02686f29a99b0ef0c.png";